(function(){
"use strict";
if(window.LumeDestinationRotator)return;
var ASSET='lume-order-destination-rotator';
var duration=30000, rows=[], label=null, mapDots=null, loading=false;
var lastKey='lume-journey-last-city-v1', lastIndex=-1, index=-1, timer=null;
function getSaved(){try{return JSON.parse(localStorage.getItem(lastKey)||'null')}catch(e){return null}}
function setSaved(value){try{localStorage.setItem(lastKey,JSON.stringify(value))}catch(e){}}
function normalize(v){return String(v||'').trim().toLowerCase()}
function key(r){return normalize(r.city)+'|'+normalize(r.state)}
function shuffle(list){for(var i=list.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1)),t=list[i];list[i]=list[j];list[j]=t}return list}
var currentSeq=[],seqPosition=0,round=0;
function buildSequence(){
 if(!rows.length)return;
 // Visit every distinct city/state before repeating any. A session's first city
 // differs from the previous one in this browser (localStorage).
 currentSeq=shuffle(rows.map(function(_,i){return i}));
 var last=getSaved();
 if(last&&currentSeq.length>1&&key(rows[currentSeq[0]])===last.key){
   var ix=currentSeq.findIndex(function(i){return key(rows[i])!==last.key});
   if(ix>0){var t=currentSeq[0];currentSeq[0]=currentSeq[ix];currentSeq[ix]=t}
 }
 seqPosition=0;round++;
}
function next(){
 if(!rows.length)return;
 if(seqPosition>=currentSeq.length)buildSequence();
 var nextIndex=currentSeq[seqPosition++];
 if(nextIndex===undefined)return;
 index=nextIndex;var d=rows[index];
 if(label){label.textContent=d.city+', '+d.state+', India';}
 if(mapDots)mapDots.highlight(d);
 setSaved({key:key(d),at:Date.now(),round:round});
}
function start(){
 if(timer)clearInterval(timer);
 if(!rows.length||!label)return;
 next();timer=setInterval(next,duration);
}
function load(url){
 if(!url||rows.length||loading)return;
 loading=true;
 fetch(url,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw Error('locations');return r.json()})
 .then(function(data){
  loading=false;
  var seen=new Set();
  rows=data.filter(function(r){return Array.isArray(r)&&/^\d{6}$/.test(String(r[0]))&&r[1]&&r[2]})
    .map(function(r){return {pin:String(r[0]),city:String(r[1]).trim(),state:String(r[2]).trim()}})
    .filter(function(r){var k=key(r);if(seen.has(k))return false;seen.add(k);return true});
  buildSequence();start();
 }).catch(function(){loading=false;if(label)label.textContent='Across India';});
}
window.LumeDestinationRotator={
 attach:function(node){
  if(!node)return;label=node;
  var box=node.closest('.lume-global-journey')?.querySelector('[data-ljx-globe]');
  if(box)load(box.dataset.amazonPins);
  else if(rows.length)start();
 },
 attachCoordinates:function(selected,group,v,T){
  // Highlight the corresponding geocoded order location without disclosing customer data.
  var byKey=new Map();
  selected.forEach(function(p){var k=normalize(p.city)+'|'+normalize(p.state);if(!byKey.has(k))byKey.set(k,p)});
  var dot=new T.Mesh(new T.SphereGeometry(.065,18,12),new T.MeshBasicMaterial({color:0xf7ffad,depthTest:true}));
  var ring=new T.Mesh(new T.RingGeometry(.078,.112,32),new T.MeshBasicMaterial({color:0xe5ffa7,transparent:true,opacity:.9,side:T.DoubleSide,depthWrite:false}));
  group.add(dot);group.add(ring);dot.visible=false;ring.visible=false;
  mapDots={highlight:function(d){
    var p=byKey.get(key(d));
    if(!p){dot.visible=false;ring.visible=false;return}
    dot.visible=true;ring.visible=true;
    dot.position.copy(v(p.lat,p.lon,1.69));
    ring.position.copy(v(p.lat,p.lon,1.702));
    ring.quaternion.setFromUnitVectors(new T.Vector3(0,0,1),v(p.lat,p.lon,1).normalize());
  }};
  if(index>=0)mapDots.highlight(rows[index]);
 }
};
function bootRotator(){var n=document.querySelector('.lume-global-journey [data-last-order-label]');if(n)window.LumeDestinationRotator.attach(n);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bootRotator);else bootRotator();
document.addEventListener('shopify:section:load',bootRotator);
document.addEventListener('shopify:section:unload',function(){if(timer){clearInterval(timer);timer=null}});
})();